export class SelfTriageProtocolRequest {
    public protocolName: string;
    public protocolDescription: string;
    public idHealthUnit: number[];
    public listIdFlowchart: number[];
}